module.exports = __webpack_public_path__ + "img/2.404a7467.png";